import { Fragment } from "react";
import { markerSegments } from "../../../domains/assistant/redaction";
import { useRedactionMarkers } from "../../../domains/assistant/useQuestionRedaction";

/**
 * A sent Question with its Markers in mint (AD-18). Only the Markers of the
 * current UI language are found: another language's show as plain text.
 */
export function RedactedQuestion({
  text,
}: {
  text: string;
}): React.JSX.Element {
  const markers = useRedactionMarkers();

  return (
    <>
      {markerSegments(text, markers).map((segment, index) =>
        segment.kind === "marker" ? (
          <span key={index} className="font-medium text-ds-mint-700">
            {segment.value}
          </span>
        ) : (
          <Fragment key={index}>{segment.value}</Fragment>
        )
      )}
    </>
  );
}
